var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#00000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "22.45%",
    cy: "8.76%",
    fx: "22.45%",
    fy: "8.76%",
    r: "113.287%",
    id: "twint_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800",
    offset: "9.157%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "17.39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB00",
    offset: "25.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    offset: "32.95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7000",
    offset: "40.46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4700",
    offset: "47.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1800",
    offset: "55.03%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    offset: "58.22%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "2.431%",
    cy: "14.525%",
    fx: "2.431%",
    fy: "14.525%",
    r: "139.175%",
    id: "twint_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0E3",
    offset: "20.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A5DB",
    offset: "38.98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0292CD",
    offset: "57.37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0377BA",
    offset: "75.46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0455A1",
    offset: "93.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054696",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.902 33.438c0 .59-.418 1.304-.933 1.599L20.941 45.465c-.516.295-1.351.295-1.867 0L1.046 35.037c-.516-.295-.933-1.008-.933-1.599V12.582c0-.59.418-1.304.933-1.599L19.074.555c.516-.295 1.351-.295 1.867 0l18.028 10.428c.516.295.933 1.008.933 1.599v20.856zm100.087-19.356h-16.137v3.861h5.796v16.503h4.568V17.943h5.772zm-73.315 0H50.513v3.861h5.796v16.503h4.568V17.943h5.796zm46.715-.639c-5.084 0-7.909 3.246-7.909 7.944v13.06h4.519V21.289c0-2.041 1.204-3.615 3.439-3.615 2.235 0 3.414 1.869 3.414 3.615v13.158h4.519v-13.06c.025-4.698-2.898-7.944-7.982-7.944zm-17.045.639v20.364h4.519V14.082zm-15.326 8.067l.147.91 4.249 11.387h1.842l5.772-20.364h-4.446l-2.751 10.699-.172 1.156-.221-1.156-3.684-10.699H80.28l-3.684 10.699-.221 1.156-.147-1.156-2.751-10.699h-4.47l5.772 20.364h1.842l4.249-11.387.147-.91",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.414 23.059l-4.716 6.911-2.407-3.689 2.775-4.156c.516-.738 1.621-2.779.344-5.558-1.032-2.263-3.267-3.345-5.232-3.345-1.965 0-4.102 1.008-5.256 3.345-1.302 2.681-.172 4.771.319 5.485 0 0 1.547 2.263 2.825 4.181l2.088 3.025 3.144 4.821c.025.025.516.787 1.4.787.835 0 1.351-.762 1.425-.836l7.368-10.92h-4.077v-.049zm-9.26.172s-1.228-1.869-2.039-3.173c-.86-1.402.098-3.492 2.039-3.492 1.94 0 2.898 2.091 2.039 3.492-.786 1.304-2.039 3.173-2.039 3.173z",
    fill: "url(#twint_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.635 29.749l-4.618-6.493s-1.228-1.869-2.039-3.173c-.86-1.402.098-3.492 2.039-3.492.246 0 .467.025.688.098l1.621-2.976a5.873 5.873 0 00-2.284-.492c-1.965 0-4.102 1.008-5.256 3.345-1.302 2.681-.172 4.771.319 5.485l8.081 11.978c.074.098.589.861 1.449.861.86 0 1.351-.738 1.425-.836l2.432-3.714-2.088-3.074-1.768 2.484z",
    fill: "url(#twint_svg__b)"
  }))));
}
export default SvgTwint;